import { BaseApi } from './BaseApi';
export class SkillApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getSkill(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('skill'),
            params: {
                id,
            },
        });
    }
    getAllSkills() {
        return this.providers.makeRequest({
            route: this.buildRoute('skills'),
        });
    }
    deleteSkill(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('skill'),
            method: 'DELETE',
            params: {
                id,
            },
        });
    }
    deleteAllSkills() {
        return this.providers.makeRequest({
            route: this.buildRoute('skills'),
            method: 'DELETE',
        });
    }
    updateSkill(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('skill'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    createSkill(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('skill'),
            method: 'POST',
            data,
        });
    }
    getSuggestedSkills() {
        return this.providers.makeRequest({
            route: this.buildRoute('skills/suggested'),
        });
    }
}
//# sourceMappingURL=skillApi.js.map